import Typography from "@portal/components/atoms/v2/typography";
import { useEffect, useState } from "react";
import { MainBox } from "../components/mainBox";
import { StartPageInfo } from "./components";
import { IPageProps } from "@portal/types/robot/IPageProps";
import { RobotTextResources } from "@portal/assets/text/RobotTextResources";
import { UserMessageComponent } from "../components/message/UserMessageComponent";
import { ClearRobotState } from "../components/helpers";
import { TextLine } from "@portal/components/atoms/v2/textLine";
import Spinner from "@portal/components/atoms/v2/spinner";
import Button from "@portal/components/atoms/v2/buttons/button";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { format } from "date-fns";
import { useSession } from "@portal/auth/client/SessionProvider";
import RobotHeaderText from "../components/robotHeaderText";
import Illustration from "@portal/components/atoms/illustrations";
import { useRobot } from "@portal/app/context/robotProvider";
import { useCreateSavingsAgreement } from "@portal/app/context/createSavingsAgreementProvider";
import { isDarkMode } from "@portal/helpers/darkMode";
import { RobotNavigateToPage } from "../components/footer";
import { inIframe } from "@portal/app/(robot)/robot/[id]/robotClientComponent";

export const StartPage = ({ centerId, isDefaultLanguage }: IPageProps) => {
  const router = useRouter();
  const { session } = useSession();
  const { clearRobotData, returningUser, savingProposalRequest } = useRobot();
  const { clearSavingAgreementData, setSavingsAgreementStartDate } = useCreateSavingsAgreement();
  const [showUserMessage, setShowUserMessage] = useState(true);
  // TODO TMP FJERNET const [isToggleBoxOpen, setIsToggleBoxOpen] = useState(false);

  const isLoggedIn = session?.status === "authenticated";
  const texts = isDefaultLanguage ? RobotTextResources.primary : RobotTextResources.secondary;

  // Clear context data if the user is different than the cached user
  useEffect(() => {
    if (isLoggedIn && returningUser) {
      const existingCustomerNumber = savingProposalRequest?.customerNumber;
      if (existingCustomerNumber !== "" && session?.user.id !== existingCustomerNumber) {
        ClearRobotState(clearSavingAgreementData, clearRobotData);
      }
    }
  }, [clearSavingAgreementData, savingProposalRequest, isLoggedIn, returningUser, session?.user.id, clearRobotData]);

  return (
    <>
      {returningUser && showUserMessage && (
        <UserMessageComponent
          userMessage={texts.VALIDATION_RETURNING}
          showDialog={showUserMessage}
          primaryButtonText={texts.MESSAGE_RESTART}
          primaryButtonClick={() => {
            setShowUserMessage(false);
            ClearRobotState(clearSavingAgreementData, clearRobotData);
            router.push(`/robot?centerId=${centerId}`);
          }}
          secondaryButtonText={texts.MESSAGE_CONTINUE}
          secondaryButtonClick={() => {
            setSavingsAgreementStartDate(format(new Date(), "yyyy-MM-dd"));
            setShowUserMessage(false);
          }}
        />
      )}
      <MainBox>
        <RobotHeaderText text={texts.PAGE_0_HEADER} />
        <TextLine wide />
        <div className="space-y-3">
          <Typography>{texts.PAGE_0_SUBHEADER}</Typography>
          <Typography>{texts.PAGE_0_SUBHEADER_1}</Typography>
          <div className="flex items-center">
            <div>
              <Typography variant="Body">
                {texts.PAGE_0_SUBHEADER_2}
                <Link
                  className="text-blueHighlighted"
                  target="_blank"
                  href={"/informasjon-til-kunder-vedrorende-ansvar-v1.pdf"}
                  prefetch={false}
                >
                  her
                </Link>
              </Typography>
            </div>
            <div className="w-64">
              {isDarkMode() ? (
                <Illustration name="finautDarkIcon" size="xxxlarge" />
              ) : (
                <Illustration name="finautIcon" size="xxxlarge" />
              )}
            </div>
          </div>
          {session?.status === "loading" && (
            <div className="flex mt-5">
              <Spinner />
            </div>
          )}
          {/* TODO TMP FJERNET <div className="flex justify-center">
            <ToggleButton
              activeText={texts.PAGE_0_BUTTON_TEXT_ACTIVE}
              inActiveText={texts.TEXT_CLOSE}
              expanded={isToggleBoxOpen}
              setExpanded={setIsToggleBoxOpen}
            />
          </div> */}
          {/* TODO TMP FJERNET {isToggleBoxOpen && */} <StartPageInfo isDefaultLanguage={isDefaultLanguage} />
        </div>
      </MainBox>
      <div className="flex w-full p-5 justify-center">
        <Button
          onClick={() => {
            const url = RobotNavigateToPage(session?.status === "authenticated", 1, centerId);
            if (inIframe()) {
              window.parent.location.href = url;
            } else {
              router.push(url);
            }
          }}
          text={texts.BUTTON_START_SAVING}
          disabled={session?.status === "loading"}
          wide
          primary
        />
      </div>
    </>
  );
};
